import gql from 'graphql-tag';
import I18n from 'i18n-js';
import React from 'react';

import { MyShippingProfilePrices } from '../../schemas/rql';

export const MyShippingProfilePricesFragment = gql`
  fragment MyShippingProfilePrices on rql_Me {
    uuid
    shop {
      _id
      shippingProfiles {
        id
        name
        localPickup
        shippingRates {
          regionCode
          regionName
          rate {
            display
          }
          incrementalRate {
            display
          }
          expeditedRate {
            display
          }
        }
      }
    }
  }
`;

interface IProps {
  shippingProfile: MyShippingProfilePrices.ShippingProfiles,
}

export default function ShippingProfileSummaryTable({ shippingProfile }: IProps) {
  const offersShipping = shippingProfile.shippingRates.length > 0;
  const offersLocalPickup = shippingProfile.localPickup;

  const displayShippingMethods = [
    offersLocalPickup && I18n.t('discovery.dashboard.selling.shippingOptions.deliveryOptions.localPickup'),
    offersShipping && I18n.t('discovery.dashboard.selling.shippingOptions.deliveryOptions.shipping'),
  ].filter(v => v);

  const doAnyRatesHaveCombinedPrice = offersShipping && shippingProfile.shippingRates.some((sr) => !!sr.incrementalRate?.display);
  const doAnyRatesHaveExpeditedPrice = offersShipping && shippingProfile.shippingRates.some((sr) => !!sr.expeditedRate?.display);

  return (
    <div className="padding-1">

      <div className="g-container">
        <div className="g-col-6 g-col-mobile-12">
          <div className="bg-white">
            <div className="styled-table styled-table--compact ws-normal">
              <table data-profile-summary>
                <tbody>
                  <tr>
                    <td>
                      <strong>
                        {I18n.t('discovery.dashboard.selling.shippingOptions.shippingProfileSummaryTable.profileName')}
                      </strong>
                    </td>
                    <td className="ws-normal">{shippingProfile.name}</td>
                  </tr>

                  <tr>
                    <td>
                      <strong>
                        {I18n.t('discovery.dashboard.selling.shippingOptions.shippingProfileSummaryTable.shippingMethods')}
                      </strong>
                    </td>
                    <td className="ws-normal">{displayShippingMethods.join(', ')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {offersShipping && (
        <div className="bg-white mt-5">
          <div className="styled-table">
            <table data-shipping-rates-table>
              <thead>
                <tr>
                  <th>{I18n.t('discovery.dashboard.selling.shippingOptions.shippingProfileSummaryTable.location')}</th>
                  <th>{I18n.t('discovery.dashboard.selling.shippingRates.rateFields.rate')}</th>
                  {doAnyRatesHaveCombinedPrice && <th>{I18n.t('discovery.dashboard.selling.shippingRates.rateFields.incrementalRate')}</th>}
                  {doAnyRatesHaveExpeditedPrice && <th>{I18n.t('discovery.dashboard.selling.shippingRates.rateFields.expeditedRate')}</th>}
                </tr>
              </thead>
              <tbody>
                {shippingProfile.shippingRates.map((sr) => (
                  <tr key={sr.regionCode}>
                    <td>
                      {sr.regionName}
                    </td>

                    <td>
                      {sr.rate?.display}
                    </td>

                    {doAnyRatesHaveCombinedPrice && (
                      <td>
                        {sr.incrementalRate?.display}
                      </td>
                    )}

                    {doAnyRatesHaveExpeditedPrice && (
                      <td>
                        {sr.expeditedRate?.display}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
